import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T, equalityFn?: (a: T, b: T) => boolean) =>
  useSelector(selector, equalityFn);
